import { Model } from './model';

export class DeductionReason extends Model {
  id: string;

  code: string;

  name: string;
}
